import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import "./roleActivity.css";
import { RoleActivityContext } from "../RoleActivityView";
import NextIcon from "../../../../assets/images/next-icon.svg";
import { useEffect } from "react";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import Loader from "../../../../components/Loader/Loader";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ActivityLog from "../../../../components/ActivityLogComponent/ActivityLog";
import InfiniteScroll from "react-infinite-scroll-component";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const RoleActivity = () => {
  const {
    roleActivityListShow,
    roleActivityList,
    roleToLogin,
    statusValue,
    buttonText,
    spinnerStatus,
    activityPageToList,
    currentPage,
    hasMore,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
  } = useContext(RoleActivityContext);

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      roleActivityListShow(currentPage);
    }, 900);
    return () => clearTimeout(timeoutID);
  }, [currentPage]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={activityPageToList}>
          {ContentData.rolePermissions.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.rolePermissions.activityRole}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container>
        <div className="pageTittles">
          {ContentData.rolePermissions.activityRole}
        </div>
        <div className="basicContainer adminTable profileInfoContainer ">
          <div className="dataActivityPage">
            <InfiniteScroll
              dataLength={roleActivityList.length} // Total items currently loaded
              next={() => roleActivityListShow(currentPage + 1)} // Load more data
              hasMore={hasMore} // Indicates if more data exists
              loader={<div className="loadingIndicator">Loading...</div>} // Loader
              endMessage={
                <p style={{ textAlign: "center" }}>No more activity logs</p>
              }
            >
              {roleActivityList.map((item, index) => (
                <ActivityLog
                  key={index}
                  name={item?.name || "-"}
                  date={item?.createdAt ? formatDate(item.createdAt) : "-"}
                  time={item?.createdAt ? formatTime(item.createdAt) : "-"}
                  activityMessage={item?.description || "-"}
                />
              ))}
            </InfiniteScroll>
          </div>
        </div>
      </Container>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            roleToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            roleActivityListShow();
          }
        }}
      />
    </div>
  );
};

export default RoleActivity;
